import _ from 'underscore';
import React from 'react';
import classNames from 'classnames';
import { DirectionalHint } from '@bingads-webui-react/fabric-control';
import { StyledBaMenuItem } from './menu-item';

const renderMenuItem = (siteMap, classes, item, dismissMenu) => (
  <StyledBaMenuItem
    className={classNames([classes.menuItem, classes.toggleable])}
    key={item.id}
    menuItemKey={item.id}
    siteMapId={item.id}
    calloutPlacement="left"
    route={item.route}
    dismissMenu={dismissMenu}
    siteMap={siteMap}
    directionalHint={DirectionalHint.leftCenter}
  >
    {item.text}
  </StyledBaMenuItem>
);

const recursiveGenerateProps = (siteMap, item, parentObject, classes, i18n) => {
  if (item.children.length === 0) {
    return;
  }

  if (parentObject.items === undefined) {
    parentObject.items = []; // eslint-disable-line no-param-reassign
  }

  _.each(item.children, (subItem) => {
    const menuItem = {
      key: subItem.id,
      text: i18n.getString(subItem.name),
      id: subItem.id,
      route: subItem.route,
    };

    if (subItem.children.length !== 0) {
      menuItem.subMenuProps = {};
      menuItem.subMenuProps.directionalHint = DirectionalHint.leftTopEdge;
      menuItem.subMenuProps.calloutProps = {
        preventDismissOnScroll: true,
      };
      menuItem.subMenuProps.ariaLabel = menuItem.text;
      recursiveGenerateProps(siteMap, subItem, menuItem.subMenuProps, classes, i18n);
    } else {
      menuItem.onRender = (subMenuItem, dismissMenu) =>
        renderMenuItem(siteMap, classes, subMenuItem, dismissMenu);
    }

    parentObject.items.push(menuItem);
  });
};


export const genereateMenuProps = (siteMap, classes, i18n) => {
  const menuProps = {};
  menuProps.items = [];
  _.each(siteMap, (item, index) => {
    menuProps.items[index] = {};

    const parentObject = menuProps.items[index];
    parentObject.key = item.id;
    parentObject.text = i18n.getString(item.name);
    parentObject.id = item.id;
    parentObject.route = item.route;
    parentObject.siteMapId = item.id;

    if (item.children.length !== 0) {
      parentObject.subMenuProps = {};
      parentObject.subMenuProps.directionalHint = DirectionalHint.leftTopEdge;
      parentObject.subMenuProps.calloutProps = {
        preventDismissOnScroll: true,
      };
      parentObject.subMenuProps.ariaLabel = parentObject.text;
      recursiveGenerateProps(siteMap, item, parentObject.subMenuProps, classes, i18n);
    } else {
      parentObject.onRender = (subMenuItem, dismissMenu) =>
        renderMenuItem(siteMap, classes, subMenuItem, dismissMenu);
    }
  });
  return menuProps;
};
